import React, { memo } from "react";
import { Box, Typography } from "@mui/material";

interface CrmIdChipProps {
  crmId: string | number;
  label?: string;
}

const CrmIdChip: React.FC<CrmIdChipProps> = ({ crmId, label = "App Id:" }) => {
  return (
    <Box
      sx={{
        display: "inline-flex",
        alignItems: "center",
        gap: 0.75,
        px: { xs: 1.2, sm: 2 },
        py: { xs: 0.1, sm: 0.2 },
        bgcolor: "#8083901A",
        border: "1px solid #E2E8E7",
        borderRadius: "999px",
        maxWidth: "100%",
      }}
    >
      <Typography
        component="span"
        sx={{
          fontSize: { xs: "12px", sm: "13px" },
          fontWeight: 500,
          color: "#4B4B4B",
          whiteSpace: "nowrap",
        }}
      >
        {label}
      </Typography>
      <Typography
        component="span"
        sx={{
          fontSize: { xs: "12px", sm: "14px" },
          fontWeight: 700,
          color: "#4B4B4B",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        }}
      >
        {crmId}
      </Typography>
    </Box>
  );
};

export default memo(CrmIdChip);
